import React from 'react';
import { ToggleSwitch } from '../../../sdk';

/**
 * Callout/quote editor
 */
export function CalloutEditor({ callout, onChange }) {
  const hasCallout = !!callout;
  
  const handleToggle = (enabled) => {
    if (enabled) {
      onChange({ label: 'Community', text: 'Every contribution becomes part of a living forest.' });
    } else {
      onChange(null);
    }
  };

  return (
    <div className="field-container">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="module-header">Callout</div>
          <div className="module-desc">Highlighted quote or note.</div>
        </div>
        <ToggleSwitch
          checked={hasCallout}
          onChange={(checked) => handleToggle(checked)}
          size="sm"
        />
      </div>

      {hasCallout && (
        <div className="mt-3 space-y-3">
          <div>
            <div className="text-[11px] text-white/55 mb-1">Label</div>
            <input
              value={callout.label || ''}
              onChange={(e) => onChange({ ...callout, label: e.target.value })}
              className="input-base"
              placeholder="e.g. Community"
            />
          </div>
          <div>
            <div className="text-[11px] text-white/55 mb-1">Text</div>
            <textarea
              value={callout.text || ''}
              onChange={(e) => onChange({ ...callout, text: e.target.value })}
              className="textarea-base"
              rows={2}
              placeholder="The quote or highlighted message"
            />
          </div>
        </div>
      )}
    </div>
  );
}
